import React from 'react';
import { PageContentFlex, PageMainColumn, PageTitle, PageTitleLine, PageWrapper } from '../Common/PageComponents';
import { Buttons, LoadingIndicator, OccupyFreeSpace, SearchField, useWindowHotkey } from '../../toolympus/components/primitives';
import { IconButton, styled } from '@mui/material';
import { Add } from '@mui/icons-material';
import { ThemeSettings } from '../../theme';
import { useContactsList } from './useContactsList';
import { useContactsSettings } from './useContactsSettings';
import { ContactsList } from './ContactsList';
import { ContactsTagsActivator } from './ContactsTagsConfiguration';
import { ContactEditDialog } from './ContactEditDialog';

interface Props {
  
}

const TitleLinks = styled(Buttons)`
  font-size: ${ThemeSettings.typography.fontSizes.smaller};
`;


export const ContactsListPage = (props: Props) => {
  const data = useContactsList();
  useWindowHotkey("alt+n", () => {
    data.newRecord.startEditing();
  });

  const { fields } = useContactsSettings();


  return (
    <PageWrapper>
      <PageTitleLine dontGrowTitle>
        <PageTitle>
        Контакты
        </PageTitle>
        <TitleLinks>
        </TitleLinks>


        <OccupyFreeSpace />
        {data.isLoading && <LoadingIndicator />}
        <SearchField
          {...data.filter}
          autoFocus
          noButton
          />
        <IconButton size="small" color="primary" onClick={() => data.newRecord.startEditing()}>
          <Add />
        </IconButton>
      </PageTitleLine>
      <PageContentFlex>
        <ContactsTagsActivator tags={data.tags} update={v => data.setTags(v || [])} />
        <PageMainColumn extraBottomPadding>
          <ContactsList
            data={data}
            fields={fields}
            editAttributes={data.editAttributes}
            startEdit={c => data.editRecord.startEditing({ ...c })}
            />
          
        </PageMainColumn>
      </PageContentFlex>

      <ContactEditDialog
        data={data.newRecord}
        schema={data.schema}
        title="Создать контакт"
        saveLabel="создать"
        />

      <ContactEditDialog
        data={data.editRecord}
        schema={data.schema}
        title="Контакт"
        remove={c => data.removeContact.run(c)}
        />
    </PageWrapper>
  );
}
